<template>
  <div class="sidebar-logo-container" style="color: #fff">
    <transition :enter-active-class="proxy?.animate.logoAnimate.enter" mode="out-in">
      <span class="sidebar-logo-link">
        <img v-if="userStore.systemInfo.icon || defaultLogo" :src="userStore.systemInfo.icon || defaultLogo" class="sidebar-logo" />
        <!-- 系统名称：单行不换行，超出时省略号 + Tooltip 悬浮提示 -->
        <ElTooltip effect="dark" :content="userStore.systemInfo.name || defaultTitle" placement="top-start" :disabled="!isTitleOverflow">
          <h1 class="sidebar-title" @mouseenter="(e) => (isTitleOverflow = e.target.scrollWidth > e.target.clientWidth)">
            {{ userStore.systemInfo.name || defaultTitle }}
          </h1>
        </ElTooltip>
      </span>
    </transition>
  </div>
</template>

<script setup lang="ts">
import variables from '@/assets/styles/variables.module.scss';
import useSettingsStore from '@/store/modules/settings';
import useUserStore from '@/store/modules/user';

const { proxy } = getCurrentInstance() as ComponentInternalInstance;
const userStore = useUserStore();
const defaultTitle = import.meta.env.VITE_APP_TITLE;
const defaultLogo = import.meta.env.VITE_APP_LOGO;
/** 系统名称是否超出容器宽度，控制 Tooltip 是否启用 */
const isTitleOverflow = ref(false);

defineProps({
  collapse: {
    type: Boolean,
    required: true
  }
});

const title = ref(import.meta.env.VITE_APP_TITLE);
const settingsStore = useSettingsStore();
const sideTheme = computed(() => settingsStore.sideTheme);
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  width: 100%;
  height: 45px;
  line-height: 45px;
  text-align: left;
  overflow: hidden;

  & .sidebar-logo-link {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;

    & .sidebar-logo {
      width: 32px;
      height: 32px;
      vertical-align: middle;
      margin-right: 12px;
      flex-shrink: 0;
    }

    & .sidebar-title {
      display: inline-block;
      margin: 0;
      color: #fff;
      font-weight: 600;
      line-height: 50px;
      font-size: 16px;
      font-family:
        Avenir,
        Helvetica Neue,
        Arial,
        Helvetica,
        sans-serif;
      vertical-align: middle;
      /* 不换行，超出容器宽度时显示省略号，悬浮通过 Tooltip 展示完整名称 */
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      max-width: 100%;
      min-width: 0;
      flex: 1;
    }
  }

  &.collapse {
    .sidebar-logo {
      margin-right: 0px;
    }
  }
}
</style>
